import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import pageImage from 'assets/missing-page.jpeg';
import Grid from '@mui/material/Grid';
import Home from '@mui/icons-material/Home';
import { landing } from 'utils/spaUrls';
import { Link } from 'react-router-dom';


export default function PageNotFound() {
  return (
    <Grid container spacing={2} textAlign='center'>
      <Grid item xs={12}>
        <img width='540px' src={pageImage} alt='Error 404: Missing page' />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6'>OOPS! LOOKS LIKE YOU STUMBLED ON A DEAD LINK</Typography>
        <Typography variant='subtitle2'>Error 404</Typography>
      </Grid>
      <Grid item xs={12}>
        <Button
          color='primary'
          component={Link}
          to={landing}
          size='large'
          startIcon={<Home />}
          variant='contained'
        >
          Take Me Home
        </Button>
      </Grid>
    </Grid>
  );
}
